import { successSnackbar } from "lib/snackbar/success-snackbar"
import { warningSnackbar } from "lib/snackbar/warning-snackbar"

export function showAddSchedulesResult(result) {
    const addedCount = Number(result?.addedCount || 0)
    const skippedCount = Number(result?.skippedCount || 0)
    const skippedNonCoreCount = Number(result?.skippedNonCoreCount || 0)
    const skippedDuplicateCount = Number(result?.skippedDuplicateCount || 0)

    if (addedCount && skippedCount) {
        warningSnackbar(buildPartialSuccessMessage())
        return
    }

    if (addedCount) {
        successSnackbar(`${addedCount} ${"schedule".pluralize(addedCount)} added to review project`)
        return
    }

    warningSnackbar(buildSkippedOnlyMessage())

    function buildPartialSuccessMessage() {
        const parts = [`${addedCount} ${"schedule".pluralize(addedCount)} added`]
        if (skippedNonCoreCount) {
            parts.push(`${skippedNonCoreCount} non-core ${"schedule".pluralize(skippedNonCoreCount)} skipped`)
        }
        if (skippedDuplicateCount) {
            parts.push(`${skippedDuplicateCount} existing ${"schedule".pluralize(skippedDuplicateCount)} skipped`)
        }
        return parts.join(". ") + "."
    }

    function buildSkippedOnlyMessage() {
        const parts = []
        if (skippedNonCoreCount) {
            parts.push(
                `No schedules were added. ${skippedNonCoreCount} non-core ${"schedule".pluralize(skippedNonCoreCount)} selected`
            )
        }
        if (skippedDuplicateCount) {
            parts.push(`${skippedDuplicateCount} already on this project`)
        }
        return parts.join(". ") + "."
    }
}
